import { createEnduroProgram } from "./enduroPrograms";
export const PROGRAM_ENDURO_34 = createEnduroProgram(3);
